import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import PropTypes from 'prop-types';
import { getRedirectLocation } from '../helpers/accountHelper';
import Routes from '../constants/routes';

class HomePage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            redirectLocation: null
        }
    }

    componentDidMount = () => {
        const user = this.props.user;

        if (user) {
            if (user.hasMultipleLocations && user.activeUserSubscriptions) {
                //get values from targeted subscription
                const currentSubscription = user.activeUserSubscriptions.find(x => x.id == user.currentSubscriptionId);
                const redirectLocation = getRedirectLocation(currentSubscription.customerRoleName, user.hasMultipleLocations);
                this.setState({ redirectLocation });
            } else {
                //user values from current user object if only 1 subscription
                const redirectLocation = getRedirectLocation(user.customerRole, user.hasMultipleLocations);
                this.setState({ redirectLocation });
            }
            
        } else {
            this.setState({ redirectLocation: Routes.LoginPage });
        }
    }

    render() {
        return (
            <Fragment>
                {
                    this.state.redirectLocation &&
                    <Redirect to={this.state.redirectLocation}/>
                }
            </Fragment>
        );
    }
}

HomePage.propTypes = {
    history: PropTypes.object.isRequired,
    user: PropTypes.object
};

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps, null)(HomePage);